export default __webpack_public_path__ + "static/media/partner-austria-wien.bf84dceb.jpg";